import React from "react";
import "./ContactInfo.scss";

function ContactInfo() {
  return (
    <div className="ContactInfo">
      <div className="contact-info-items">
        <p className="contact-info-item">email:</p>
        <p className="contact-info-item">info@makeupbyellie.com</p>
      </div>
    </div>
  );
}

export default ContactInfo;
